import { useEffect, useMemo, useState, useCallback } from 'react';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useAppStore } from '@/store';
import { useTradeStore } from '../store';
import { useSmartWebSocket } from '../wsContext';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';

interface ITokenTradeInfo {
  totalBuyCost: number;
  totalBuyAmount: number;
  curPirce: number;
  avgBuyPrice: number;
}

export const useWsHoldingUpdate = () => {
  const { chainInfo } = useAppStore();
  const { walletAddress } = useBoomWallet();
  const { tokenInfo } = useTradeStore();
  const [tokenTradeInfo, setTokenTradeInfo] = useState<ITokenTradeInfo>();
  const { isConnected, sendMessage, data: wsData, disconnect } = useSmartWebSocket();
  const { publish } = useAppEventBusContext();
  const params = useMemo(() => {
    return { chain: chainInfo.chain == 'bsc' ? 'evm:56' : 'sol', channel: 'pnl-update', walletAddress, tokenAddress: tokenInfo?.address };
  }, [chainInfo, walletAddress, tokenInfo?.address]);

  const subscribeToWebSocket = useCallback(() => {
    if (isConnected && params?.tokenAddress) {
      sendMessage('subscribe', params);
      return () => sendMessage('unSubscribe', params);
    }
  }, [isConnected, params]);

  const handleWebSocketUpdate = useCallback(() => {
    if (!wsData) return;
    if (wsData.channel.includes('pnl-update')) {
      const { totalBuyCost, totalBuyAmount, curPirce } = wsData.data;
      setTokenTradeInfo({ totalBuyCost, totalBuyAmount, curPirce, avgBuyPrice: 0 });
      publish(SubscribeEvent.Refresh_Holding);
    }
  }, [isConnected, wsData]);

  useEffect(subscribeToWebSocket, [subscribeToWebSocket]);
  useEffect(handleWebSocketUpdate, [handleWebSocketUpdate]);

  useEffect(() => {
    return () => disconnect();
  }, []);

  return { tokenTradeInfo, setTokenTradeInfo };
};
